import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import AffiliateTree from "../@Components/Affiliates/AffiliateTree";

const Affiliates: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <AffiliateTree />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default Affiliates;
